const groupPrefix = 'cms-locations'
const relatedPrefix = 'cms-locations-related'

export const apiCMSLocations = {
	fetchCMSLocation: async (locationID: number) => {
		const { data } = await apiCommon<ICMSLocation>(`${groupPrefix}/${locationID}`, { method: 'GET' })
		return CMSLocationFromJSON(data)
	},

	fetchCMSLocationBySlug: async (slug: string, locale: string, isActive: boolean) => {
		let url = `${groupPrefix}/slug/find`

		const queryParams = []

		if (slug) {
			queryParams.push(`slug=${slug}`)
		}

		if (locale) {
			queryParams.push(`locale=${locale}`)
		}

		if (isActive) {
			queryParams.push(`is_active=${isActive}`)
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data } = await apiCommon<any>(url, {
			method: 'GET',
		})

		if (!data) return { response: [] }

		const response = CMSLocationFromJSON(data)

		return { data: response }
	},

	fetchAllCMSLocations: async (page = 1, perPage = 10, name?: string, assign = false, parent_id?: number, only_active = false, lang?: string) => {
		let url = groupPrefix

		const queryParams = []

		if (perPage && page) {
			queryParams.push(`per_page=${perPage}`)
			queryParams.push(`page=${page}`)
		}

		if (name) {
			queryParams.push(`name=${encodeURIComponent(name)}`)
		}

		if (assign) {
			queryParams.push(`assign=${assign}`)
		}

		if (parent_id) {
			queryParams.push(`parent_id=${parent_id}`)
		}

		if (only_active) {
			queryParams.push(`only_active=${only_active}`)
		}

		if (lang) {
			queryParams.push(`lang=${lang}`)
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data, links, meta } = await apiCommon<ICMSLocation[]>(url, {
			method: 'GET',
		})

		if (!data) return { response: [], links, meta }

		const response = data.map((location) => {
			return CMSLocationFromJSON(location)
		})
		return { data: response, links, meta }
	},

	updateCMSLocation: async (locationData: ICMSLocationModel, locationID: number) => {
		const { data } = await apiCommon<ICMSLocation>(`${groupPrefix}/${locationID}`, { method: 'PUT', body: CMSLocationToJSON(locationData) })
		return CMSLocationFromJSON(data)
	},

	createCMSLocation: async (locationData: ICMSLocationModel) => {
		const { data } = await apiCommon<ICMSLocation>(`${groupPrefix}`, {
			method: 'POST',
			body: CMSLocationToJSON(locationData),
		})
		return CMSLocationFromJSON(data)
	},

	deleteCMSLocation: async (locationID: number) => {
		const data = await apiCommon<string>(`${groupPrefix}/${locationID}`, { method: 'DELETE' })
		return data
	},

	fetchAllRelatedLocations: async () => {
		const { data } = await apiCommon<ICMSLocationRelatedExtended[]>(`${relatedPrefix}`, { method: 'GET' })
		if (!data) return { response: [] }

		const response = data.map((location) => {
			return CMSLocationRelatedExtendedFromJSON(location)
		})

		return { data: response }
	},

	fetchAssignedLocations: async (locationID: number) => {
		const { data } = await apiCommon<ICMSLocationRelated[]>(`${relatedPrefix}/${locationID}`, { method: 'GET' })
		if (!data) return { response: [] }

		const response = data.map((location) => {
			return CMSLocationRelatedFromJSON(location)
		})

		return { data: response }
	},

	assignRelatedLocations: async (locationsToAdd: number[], locationsToRemove: number[], locationID: number) => {
		const data = await apiCommon<any>(`${relatedPrefix}/${locationID}`, {
			method: 'PUT',
			body: {
				locations_to_add: locationsToAdd,
				locations_to_remove: locationsToRemove,
			},
		})
		return data
	},

	fetchClosestLocations: async (locationID: number) => {
		const { data } = await apiCommon<ICMSLocation[]>(`${groupPrefix}/${locationID}/closest`, { method: 'GET' })
		if (!data) return { response: [] }

		const response = data.map((location) => {
			return CMSLocationFromJSON(location)
		})

		return { data: response }
	},
}
